import axios from "axios"
import { post, del, get, put } from "./api_helper"
import * as url from "./url_helper"
import { toast } from "react-toastify";

// Create course
export const createCourse = data => post(url.CREATE_COURSE, data);
export const updateCourse = data => put(url.UPDATE_COURSE, data);
export const deleteCourse = id => del(url.DELETE_COURSE + id);
export const fetchAllCourses = () => get(url.FETCH_ALL_COURSES);
export const fetchSingleCourse = id => get(url.FETCH_SINGLE_COURSE + id);

export const fetchCourseNames = () => get(url.FETCH_COURSE_NAMES);

